export const PLAN_LEVELS = [
  'pro_1',
  'pro_2',
  'pro_3',
  'pro_4',
  'pro_5',
  'pro_6',
  'pro_7',
  'pro_8',
  'pro_9',
  'pro_10',
  'pro_11',
  'pro_12',
  'pro_13',
  'pro_14',
  'teams_1',
  'teams_2',
  'teams_3',
  'teams_4',
  'teams_5',
  'teams_6',
  'teams_7',
  'teams_8',
  'teams_9',
  'teams_10',
  'teams_11',
  'teams_12',
  'teams_13',
  'teams_14',
] as const;
export type PlanLevel = (typeof PLAN_LEVELS)[number];

export interface NameInfo {
  name: string;
  level: PlanLevel;
  namePrice?: string | undefined;
}

export const PLAN_LEVEL_MAP = {
  pro_1: { name: 'Pro', namePrice: undefined, level: 'pro_1' },
  pro_2: { name: 'Pro', namePrice: '50', level: 'pro_2' },
  pro_3: { name: 'Pro', namePrice: '100', level: 'pro_3' },
  pro_4: { name: 'Pro', namePrice: '200', level: 'pro_4' },
  pro_5: { name: 'Pro', namePrice: '300', level: 'pro_5' },
  pro_6: { name: 'Pro', namePrice: '400', level: 'pro_6' },
  pro_7: { name: 'Pro', namePrice: '500', level: 'pro_7' },
  pro_8: { name: 'Pro', namePrice: '600', level: 'pro_8' },
  pro_9: { name: 'Pro', namePrice: '700', level: 'pro_9' },
  pro_10: { name: 'Pro', namePrice: '800', level: 'pro_10' },
  pro_11: { name: 'Pro', namePrice: '900', level: 'pro_11' },
  pro_12: { name: 'Pro', namePrice: '1000', level: 'pro_12' },
  pro_13: { name: 'Pro', namePrice: '1500', level: 'pro_13' },
  pro_14: { name: 'Pro', namePrice: '2000', level: 'pro_14' },
  teams_1: { name: 'Teams', namePrice: undefined, level: 'teams_1' },
  teams_2: { name: 'Teams', namePrice: '60', level: 'teams_2' },
  teams_3: { name: 'Teams', namePrice: '110', level: 'teams_3' },
  teams_4: { name: 'Teams', namePrice: '200', level: 'teams_4' },
  teams_5: { name: 'Teams', namePrice: '300', level: 'teams_5' },
  teams_6: { name: 'Teams', namePrice: '400', level: 'teams_6' },
  teams_7: { name: 'Teams', namePrice: '500', level: 'teams_7' },
  teams_8: { name: 'Teams', namePrice: '600', level: 'teams_8' },
  teams_9: { name: 'Teams', namePrice: '700', level: 'teams_9' },
  teams_10: { name: 'Teams', namePrice: '800', level: 'teams_10' },
  teams_11: { name: 'Teams', namePrice: '900', level: 'teams_11' },
  teams_12: { name: 'Teams', namePrice: '1000', level: 'teams_12' },
  teams_13: { name: 'Teams', namePrice: '1500', level: 'teams_13' },
  teams_14: { name: 'Teams', namePrice: '2000', level: 'teams_14' },
} satisfies { [key: string]: NameInfo };
